<template>
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form class="form" @submit.prevent autocomplete="off">
            <div v-loading="loading" class="p-5 rounded-lg border  bg-white">
                <header>
                    <div style="display: flex; justify-content: end">
                        <div style="display: flex; align-items: center; gap: 4px;" class="mb-3">
                            <el-button class="p-2" v-if="indexQuestion > 0"
                                style="background-color: #bab9bc; color: #000;font-size: 13px; "
                                @click="prevQuestion">Câu trước</el-button>
                            <el-button class="p-2" style="background-color: #554B7E; color: #f9f7fb;font-size: 13px"
                                @click="handleSubmit(nextOrSubmit)">
                                {{ rightTextButton }}</el-button>
                        </div>
                    </div>
                </header>
                <main>
                    <section>
                        <MakeWriting v-if="currentQuestion?.typeAnswer === WRITE_PARAGRAPH"
                            :currentHomework="currentQuestion" :typeCourse="typeCourse"
                            :forceValidate="submitAttempted"
                            :key="currentQuestion.id">
                        </MakeWriting>
                        <MakePronunciation v-if="currentQuestion?.typeAnswer === PRONUNCIATION"
                            :currentHomework="currentQuestion" :typeCourse="typeCourse"
                            :forceValidate="submitAttempted"
                            :key="currentQuestion.id">
                        </MakePronunciation>
                        <MakeFillReading v-if="[FILL_GRAMMAR, READING_PASSAGE].includes(currentQuestion?.typeAnswer)"
                            :currentHomework="currentQuestion" :typeCourse="typeCourse"
                            :forceValidate="submitAttempted"
                            :key="currentQuestion.id">
                        </MakeFillReading>
                        <MakeRecordAndVideo v-else-if="currentQuestion?.type_group === 'speaking'"
                            :currentHomework="currentQuestion" :typeCourse="typeCourse"
                            :forceValidate="submitAttempted"
                            :key="currentQuestion.id ?? -1">
                        </MakeRecordAndVideo>
                    </section>
                </main>
            </div>
        </form>
    </ValidationObserver>
</template>

<script>
import { MakeWriting, MakePronunciation, MakeFillReading, MakeRecordAndVideo } from './components';
import { WRITE_PARAGRAPH, PRONUNCIATION, FILL_GRAMMAR, READING_PASSAGE, RECORD_AUDIO, RECORD_VIDEO } from './constant';
import { ADMIN_MARK_HOMEWORK, ADMIN_MARK_HOMEWORK_V2 } from "@/core/services/store/course/classes.module";
import { INSPECTION_POST_MARK } from "@/core/services/store/inspection/inspection.module";
import ApiService from "@/core/services/api.service";
export default {
    components: { MakeWriting, MakePronunciation, MakeFillReading, MakeRecordAndVideo },
    props: {
        groupQuestions: {
            type: Array,
            default: () => []
        },
        typeCourse: {
            type: Number,
            default: 0
        },
        course_student_id: {
            type: Number,
            default: null
        },
        type : {
            type: String,
            default: false
        },
        order : {
            type: [Number, String],
            default: null
        },
        overall_id: {
            type: [Number, String],
            default: null
        }
    },
    data() {
        return {
            loading: false,
            WRITE_PARAGRAPH,
            PRONUNCIATION,
            FILL_GRAMMAR,
            READING_PASSAGE,
            RECORD_AUDIO,
            RECORD_VIDEO,
            indexQuestion : 0,
            submitAttempted: false
        }
    },
    computed: {
        currentQuestion() {
            return this.groupQuestions[this.indexQuestion]
        },
        isSubmit() {
            return this.groupQuestions.length === this.indexQuestion + 1
        },
        rightTextButton() {
            return this.isSubmit ? "Lưu" : "Câu sau"
        },
        resolvedOverallId() {
            const q = this.$route.query.overall_id
            if (q !== undefined && q !== null && q !== '') {
                return q
            }
            return ''
        }
    },
    methods: {
        nextOrSubmit() {
            if (this.loading) {
                return
            }

            this.submitAttempted = false
            if(this.isSubmit) {
                this.submitAttempted = true
                if (!this.validateCurrentQuestion(this.currentQuestion)) {
                    return
                }
                this.handleSubmit()
            } else {
                this.nextQuestion()
            }
        },
        nextQuestion() {
            if (this.loading) {
                return
            }

            this.submitAttempted = false
            this.indexQuestion += 1
        },
        prevQuestion() {
            if (this.loading) {
                return
            }

            this.submitAttempted = false
            this.indexQuestion -= 1
        },
        validateSpeakingQuestion(question) {
            const speakingEvaluation = question?.speakingEvaluation || {}
            const evaluations = question?.evaluations || {}

            if (speakingEvaluation.evaluationStatus === 'fail') {
                return !!speakingEvaluation.notMeetReason
            }

            return Object.values(evaluations).every((skill) => {
                const score = skill?.score
                const comment = skill?.comment || ''
                const hasScore = score !== null && score !== undefined && score !== ''
                const hasValidComment = comment.indexOf('blob:') === 0 || comment.trim().length >= 50
                return hasScore && hasValidComment
            })
        },
        validatePronunciationQuestion(question) {
            const score = question?.score
            const comment = question?.comment || ''
            const hasScore = score !== null && score !== undefined && score !== '' && Number(score) > 0

            if (!hasScore) {
                return false
            }

            if (Number(score) > 0 && Number(score) < 7) {
                return comment.indexOf('blob:') === 0 || comment.trim().length >= 50
            }

            return true
        },
        validateWritingQuestion(question) {
            const speakingEvaluation = question?.speakingEvaluation || {}
            if (speakingEvaluation.evaluationStatus === 'fail') {
                return !!speakingEvaluation.notMeetReason
            }

            const criteria = [
                question?.achievement,
                question?.lexical,
                question?.coherence,
                question?.grammatical
            ]
            const allCriteriaFilled = criteria.every((score) => score !== null && score !== undefined && score !== '' && Number(score) > 0)
            if (!allCriteriaFilled) {
                return false
            }

            if (question?.achieveMinComment === false) {
                return false
            }

            const score = Number(question?.score || 0)
            const comment = question?.comment || ''
            const isLowCourse = Number(this.typeCourse) === 10
            if (isLowCourse && score > 0 && score < 7) {
                return comment.indexOf('blob:') === 0 || comment.trim().length >= 30
            }

            return true
        },
        validateFillReadingQuestion(question) {
            const score = question?.score
            const comment = question?.comment || ''
            const hasScore = score !== null && score !== undefined && score !== '' && Number(score) > 0
            const minimumCommentReached = question?.achieveMinComment !== false

            if (!hasScore || !minimumCommentReached) {
                return false
            }

            if (Number(score) > 0 && Number(score) < 7) {
                return comment.indexOf('blob:') === 0 || comment.trim().length >= 50
            }

            return true
        },
        validateCurrentQuestion(question) {
            if (!question) {
                return false
            }

            if (question?.type_group === 'speaking') {
                return this.validateSpeakingQuestion(question)
            }

            if (question?.typeAnswer === WRITE_PARAGRAPH) {
                return this.validateWritingQuestion(question)
            }

            if (question?.typeAnswer === PRONUNCIATION) {
                return this.validatePronunciationQuestion(question)
            }

            if ([FILL_GRAMMAR, READING_PASSAGE].includes(question?.typeAnswer)) {
                return this.validateFillReadingQuestion(question)
            }

            return true
        },
        flattenedHomework() {
            return this.groupQuestions.flatMap((homeWork) => {
                if (homeWork?.type_group === 'speaking') {
                    return (homeWork.data || []).map((item) => ({
                        ...item,
                        typeHomework: item?.typeHomework || item?.typeAnswer,
                        fluency: homeWork.evaluations?.fluency || {},
                        vocabularyRange: homeWork.evaluations?.vocabularyRange || {},
                        grammaticalRange: homeWork.evaluations?.grammaticalRange || {},
                        pronunciation: homeWork.evaluations?.pronunciation || {},
                        score: homeWork.totalScore ?? homeWork.score ?? 0,
                        speakingEvaluation: homeWork.speakingEvaluation || {}
                    }))
                }
                return [{
                    ...homeWork,
                    typeHomework: homeWork?.typeHomework || homeWork?.typeAnswer
                }]
            })
        },
        transformSpeakingEvaluationData(speakingEvaluation = {}) {
            const status = speakingEvaluation?.evaluationStatus ?? 'pass'
            return {
                skill_assessment: status === 'pass' ? '1' : '0',
                disqualification_reason: speakingEvaluation?.notMeetReason || '',
                disqualification_reason_detail: speakingEvaluation?.notMeetDescription || ''
            }
        },
        processCommonWritingData(homeWork) {
            const { skill_assessment, disqualification_reason, disqualification_reason_detail } =
                this.transformSpeakingEvaluationData(homeWork?.speakingEvaluation)

            return {
                skill_assessment,
                disqualification_reason,
                disqualification_reason_detail
            }
        },
        async blobUrlToFile(blobUrl, fileName) {
            const response = await fetch(blobUrl)
            const blob = await response.blob()
            return new File([blob], fileName, { type: 'audio/wav' })
        },
        processComment(comment, outcomesId, type, audioFiles) {
            if (comment && comment.startsWith('blob:')) {
                const overallId = this.resolvedOverallId || this.overall_id || '0'
                const fileName = `audio_${overallId}_${type}_${outcomesId ?? 0}`
                audioFiles.push({ blobUrl: comment, fileName })
                return { comment: fileName, type: 'file' }
            }
            return { comment: comment || '', type: 'text' }
        },
        processCommonSpeakingData(flattenedListHomework, audioFiles) {
            const firstSpeakingItem = flattenedListHomework.find((hw) => [RECORD_VIDEO, RECORD_AUDIO].includes(hw.typeAnswer))

            if (!firstSpeakingItem) return null

            const { skill_assessment, disqualification_reason, disqualification_reason_detail } =
                this.transformSpeakingEvaluationData(firstSpeakingItem?.speakingEvaluation)

            const fluencyOverall = this.processComment(firstSpeakingItem?.fluency?.comment, null, 'fluency', audioFiles)
            const vocabOverall = this.processComment(firstSpeakingItem?.vocabularyRange?.comment, null, 'vocabularyRange', audioFiles)
            const grammarOverall = this.processComment(firstSpeakingItem?.grammaticalRange?.comment, null, 'grammaticalRange', audioFiles)
            const pronunOverall = this.processComment(firstSpeakingItem?.pronunciation?.comment, null, 'pronunciation', audioFiles)

            return {
                skill_assessment,
                disqualification_reason,
                disqualification_reason_detail,
                overallEvaluation: [
                    {
                        fluency: fluencyOverall.comment,
                        type: fluencyOverall.type
                    },
                    {
                        vocabularyRange: vocabOverall.comment,
                        type: vocabOverall.type
                    },
                    {
                        grammaticalRange: grammarOverall.comment,
                        type: grammarOverall.type
                    },
                    {
                        pronunciation: pronunOverall.comment,
                        type: pronunOverall.type
                    }
                ]
            }
        },
        processSpeakingDetail(homeWork, audioFiles) {
            return {
                fluencyDetail: this.processComment(homeWork?.fluency?.detailedComments?.[homeWork.outcomes_id], homeWork.outcomes_id, 'fluency', audioFiles),
                vocabDetail: this.processComment(homeWork?.vocabularyRange?.detailedComments?.[homeWork.outcomes_id], homeWork.outcomes_id, 'vocabularyRange', audioFiles),
                grammarDetail: this.processComment(homeWork?.grammaticalRange?.detailedComments?.[homeWork.outcomes_id], homeWork.outcomes_id, 'grammaticalRange', audioFiles),
                pronunDetail: this.processComment(homeWork?.pronunciation?.detailedComments?.[homeWork.outcomes_id], homeWork.outcomes_id, 'pronunciation', audioFiles)
            }
        },
        buildSubmitResults(flattenedListHomework, commonScore, audioFiles) {
            return flattenedListHomework.map((homeWork) => {
                const typeHomework = homeWork?.typeHomework || homeWork?.typeAnswer
                const itemPayload = {
                    score: homeWork?.totalScore ?? homeWork?.score ?? 0,
                    outcomes_id: homeWork?.outcomes_id,
                    comment: homeWork?.comment || '',
                    comment_phase: 'nhận xét theo giai đoạn'
                }

                if (typeHomework === WRITE_PARAGRAPH) {
                    const totalDetail = this.processComment(homeWork?.comment, homeWork?.outcomes_id, 'totalScore', audioFiles)
                    const { skill_assessment, disqualification_reason, disqualification_reason_detail } = this.processCommonWritingData(homeWork)

                    return {
                        score: homeWork?.score ?? homeWork?.totalScore ?? 0,
                        outcomes_id: homeWork?.outcomes_id,
                        overall_id: this.resolvedOverallId ?? this.overall_id,
                        typeHomework: typeHomework,
                        skill_assessment,
                        disqualification_reason,
                        disqualification_reason_detail,
                        comments: homeWork?.listComment || homeWork?.commentToAnswer || [],
                        score_detail: {
                            'task-achievement': homeWork?.achievement ?? null,
                            'lexical-resource': homeWork?.lexical ?? null,
                            'coherence-and-cohesion': homeWork?.coherence ?? null,
                            'grammatical-range-and-accuracy': homeWork?.grammatical ?? null
                        },
                        general_comments: [
                            {
                                totalScore: totalDetail.comment,
                                type: totalDetail.type
                            }
                        ]
                    }
                }

                if ([FILL_GRAMMAR, READING_PASSAGE].includes(typeHomework)) {
                    const totalDetail = this.processComment(homeWork?.comment, homeWork?.outcomes_id, 'totalScore', audioFiles)
                    return {
                        outcomes_id: homeWork?.outcomes_id,
                        score: homeWork?.score ?? 0,
                        comments: homeWork?.listComment || homeWork?.commentToAnswer || [],
                        general_comments: [
                            {
                                totalScore: totalDetail.comment,
                                type: totalDetail.type
                            }
                        ]
                    }
                }

                if (typeHomework === PRONUNCIATION) {
                    const result = {
                        outcomes_id: homeWork?.outcomes_id,
                        score: homeWork?.score ?? 0
                    }

                    if (homeWork?.comment) {
                        const totalDetail = this.processComment(homeWork.comment, homeWork.outcomes_id, 'totalScore', audioFiles)
                        result.comments = [
                            {
                                totalScore: totalDetail.comment,
                                type: totalDetail.type
                            }
                        ]
                    }

                    return result
                }

                if ([RECORD_VIDEO, RECORD_AUDIO].includes(typeHomework)) {
                    const { fluencyDetail, vocabDetail, grammarDetail, pronunDetail } = this.processSpeakingDetail(homeWork, audioFiles)
                    return {
                        outcomes_id: homeWork?.outcomes_id,
                        score: commonScore,
                        comments: [
                            {
                                fluency: fluencyDetail.comment,
                                type: fluencyDetail.type
                            },
                            {
                                vocabularyRange: vocabDetail.comment,
                                type: vocabDetail.type
                            },
                            {
                                grammaticalRange: grammarDetail.comment,
                                type: grammarDetail.type
                            },
                            {
                                pronunciation: pronunDetail.comment,
                                type: pronunDetail.type
                            }
                        ],
                        score_detail: {
                            fluency: homeWork?.fluency?.score ?? null,
                            vocabularyRange: homeWork?.vocabularyRange?.score ?? null,
                            grammaticalRange: homeWork?.grammaticalRange?.score ?? null,
                            pronunciation: homeWork?.pronunciation?.score ?? null
                        }
                    }
                }

                return {
                    ...itemPayload,
                    comments: [
                        { fluency: homeWork?.fluency?.comment || '' },
                        { vocabularyRange: homeWork?.vocabularyRange?.comment || '' },
                        { grammaticalRange: homeWork?.grammaticalRange?.comment || '' },
                        { pronunciation: homeWork?.pronunciation?.comment || '' }
                    ],
                    score_detail: {
                        fluency: homeWork?.fluency?.score ?? null,
                        vocabularyRange: homeWork?.vocabularyRange?.score ?? null,
                        grammaticalRange: homeWork?.grammaticalRange?.score ?? null,
                        pronunciation: homeWork?.pronunciation?.score ?? null
                    }
                }
            }).filter(Boolean)
        },
        async appendAudioFilesToFormData(formData, audioFiles) {
            const files = await Promise.all(
                audioFiles.map(({ blobUrl, fileName }) => this.blobUrlToFile(blobUrl, fileName))
            )

            files.forEach((file) => {
                formData.append(file.name, file)
            })
        },
        buildSpeakingSubmitFormData(results, commonSpeaking) {
            const formData = new FormData()
            formData.append('lesson', this.$route.query.lesson || this.$route.params.id || '')
            formData.append('classroom_id', this.$route.query.classroom_id || '')
            formData.append('course_student_id', this.course_student_id || '')
            formData.append('overall_result_id', this.resolvedOverallId || this.overall_id || '')
            formData.append('type', 'homework')
            formData.append('results', JSON.stringify(results))
            if (this.type === 'remark-inspection') {
                formData.append('id', this.$route.query.inspection_id || '')
            }

            if (commonSpeaking) {
                const payloadCommonSpeaking = this.getSubmitEndpoint() === ADMIN_MARK_HOMEWORK_V2
                    ? { ...commonSpeaking, is_redo: 1 }
                    : commonSpeaking

                formData.append('common_speaking', JSON.stringify(payloadCommonSpeaking))
            }

            return formData
        },
        getSubmitEndpoint() {
            if (!this.type) {
                return ADMIN_MARK_HOMEWORK
            }

            return this.type === 'remark-inspection' ? INSPECTION_POST_MARK : ADMIN_MARK_HOMEWORK_V2
        },

        async submitHomework() {
            const flattenedListHomework = this.flattenedHomework()
            const firstSpeakingItem = flattenedListHomework.find((hw) => [RECORD_VIDEO, RECORD_AUDIO].includes(hw?.typeHomework || hw?.typeAnswer))

            const audioFiles = []
            const commonSpeaking = firstSpeakingItem ? this.processCommonSpeakingData(flattenedListHomework, audioFiles) : null
            const commonScore = firstSpeakingItem?.score ?? 0
            const results = this.buildSubmitResults(flattenedListHomework, commonScore, audioFiles)
            const formData = this.buildSpeakingSubmitFormData(results, commonSpeaking)
            await this.appendAudioFilesToFormData(formData, audioFiles)

            this.loading = true

            try {
                await ApiService.upload(this.getSubmitEndpoint(), formData)
                this.$message({
                    type: "success",
                    message: "Chấm điểm thành công!",
                    showClose: true,
                });
                this.$router.push({
                    name: 'list_mark_all_homework',
                    params: { id: this.$route.params.id },
                    query: {
                        classroom_id: this.$route.query.classroom_id,
                        lesson: this.$route.query.lesson,
                        learning_schedule_id: this.$route.query.learning_schedule_id
                    }
                });
                return 'success'
            } catch (error) {
                const message = error?.response?.data?.message || 'Có lỗi xảy ra khi chấm bài'
                this.$message({
                    type: "error",
                    message: "Sever đang bận! " + message,
                    showClose: true,
                });
                return 'error'
            } finally {
                this.loading = false
            }
        },
        async handleSubmit() {
            if (this.loading) {
                return 'loading'
            }

            const status = await this.submitHomework()

            return status
        }
    }
}
</script>
